import isEmpty from 'lodash/isEmpty'
import $ from 'jquery'
import moment from 'moment'

export default newsletterModal

/** @ngInject */
function newsletterModal($uibModal, $timeout, $cookies, DeviceChecker) {
    return ({
        restrict: 'E',
        link($scope) {
            const MOBILE_DISPLAY_DELAY = 7000
            const LANDING_ID_CAMPAIGN = 'LANDING_NEWSLETTER'
            const COOKIE_LABEL_HAS_OPENED_NEWSLETTER = 'hasOpenedNewsletterOnce'
            const COOKIE_EXPIRE_DATE = moment().add(15, 'day').toDate()

            let hasOpenedOnce = false
            const openNewsletterModal = function () {
                if (!hasOpenedOnce) {
                    hasOpenedOnce = true
                    $cookies.put(COOKIE_LABEL_HAS_OPENED_NEWSLETTER, true, { expires: COOKIE_EXPIRE_DATE })
                    const referrer = isEmpty(document.referrer) ? undefined : document.referrer
                    return $uibModal.open({
                        animation: true,
                        size: 'lg',
                        template: require('./modal-newsletter.jade')(),
                        backdrop: 'static',
                        windowClass: 'newsletter-modal modal-vertical-center',
                        controller($scope, $uibModalInstance, CampaignLanding, CampaignLandingType) {
                            $scope.form = {
                                email: '',
                            }
                            $scope.isSubmitted = false
                            $scope.submit = function () {
                                CampaignLanding.submitCampaignInformation({
                                    id_campaign: LANDING_ID_CAMPAIGN,
                                    type: CampaignLandingType.SUBSCRIBE,
                                    referrer,
                                    mail: $scope.form.email,
                                })
                                $scope.isSubmitted = true
                            }

                            $scope.close = () => $uibModalInstance.dismiss()
                        },
                    })
                }
            }

            const activate = function () {
                if (!$cookies.get(COOKIE_LABEL_HAS_OPENED_NEWSLETTER)) {
                    if (DeviceChecker.isMobile()) {
                        const delayedOpenNewsletterModal$ = $timeout(openNewsletterModal, MOBILE_DISPLAY_DELAY)

                        return $scope.$on('$destroy', () => $timeout.cancel(delayedOpenNewsletterModal$))
                    }
                    $('body').on('mouseleave.landingNewsletterModal', openNewsletterModal)

                    return $scope.$on('$destroy', () => $('body').off('mouseleave.landingNewsletterModal'))
                }
            }

            activate()
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/newsletterModal/newsletterModal.js